export default "__VITE_ASSET__DXERqHVM__"